import { PlayCircleIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const PlayCircle = /* @__PURE__ */ createIcon(PlayCircleIcon, 'PlayCircle');
